export const NOTIFICATIONS_TABS = [
  // { id: 1, value: 'all', translate: 'NOTIFICATIONS.ALL' },
  // { id: 2, value: 'order', translate: 'NOTIFICATIONS.ORDERS' },
  // { id: 3, value: 'appeal', translate: 'NOTIFICATIONS.APPEALS' },
  // { id: 4, value: 'payment', translate: 'NOTIFICATIONS.PAYMENTS' },
  // { id: 5, value: 'news', translate: 'NOTIFICATIONS.NEWS' },
  { id: 6, value: 'meeting', translate: 'NOTIFICATIONS.MEETINGS' },
];
